﻿import Confirmation from "./Confirmation.svelte";
import LandingPage from "./LandingPage.svelte";
import PersonalDetails from "./PersonalDetails.svelte";
import RegistrationComplete from "./RegistrationComplete.svelte";
import Review from "./Review.svelte";
import SaveAndCloseThankYou from "./SaveAndCloseThankYou.svelte";
import ThankYou from "./ThankYou.svelte";
import Verify from "./Verify.svelte";
import ClaimDetails from "./ClaimDetails.svelte";
import ClaimDetailsImpact from "./ClaimDetailsImpact.svelte";
import ClaimDetailsTreatment from "./ClaimDetailsTreatment.svelte";
import DocumentUpload from "./DocumentUpload.svelte";

const title = "Social Media Class Action Investigation";

const registrationPageList = [
	{
		pageIndex: 0,
		component: LandingPage,
		title: null,
		showInTracker: false,
		routeId: "/Registration",
		nextPage: "/Registration/PersonalDetails",
		properties: {
			pageTitle: `${title}`,
			lastVisitedPage: "Landing Page"
		}
	},
	{
		pageIndex: 1,
		component: PersonalDetails,
		title: "Personal Details",
		showInTracker: true,
		routeId: "/Registration/PersonalDetails",
		nextPage: "/Registration/ClaimDetails",
		previousPage: "/Registration",
		properties: {
			pageTitle: `${title} - Personal Details`,
			persistUrl: "/api/project",
			lastVisitedPage: "Personal Details"
		}
	},
	{
		pageIndex: 2,
		component: ClaimDetails,
		title: "Claim Details - Social Media",
		showInTracker: true,
		routeId: "/Registration/ClaimDetails",
		nextPage: "/Registration/ClaimDetailsImpact",
		previousPage: "/Registration/PersonalDetails",
		properties: {
			pageTitle: `${title} - Claim Details - Social Media`,
			persistUrl: "/api/project",
			lastVisitedPage: "Claim Details - Social Media"
		}
	},
	{
		pageIndex: 3,
		component: ClaimDetailsImpact,
		title: "Claim Details - Impact",
		showInTracker: true,
		routeId: "/Registration/ClaimDetailsImpact",
		nextPage: "/Registration/ClaimDetailsTreatment",
		previousPage: "/Registration/ClaimDetails",
		properties: {
			pageTitle: `${title} - Claim Details - Impact`,
			persistUrl: "/api/project",
			lastVisitedPage: "Claim Details - Impact"
		}
	},
	{
		pageIndex: 4,
		component: ClaimDetailsTreatment,
		title: "Claim Details - Treatment",
		showInTracker: true,
		routeId: "/Registration/ClaimDetailsTreatment",
		nextPage: "/Registration/DocumentUpload",
		previousPage: "/Registration/ClaimDetailsImpact",
		properties: {
			pageTitle: `${title} - Claim Details - Treatment`,
			persistUrl: "/api/project",
			lastVisitedPage: "Claim Details - Treatment"
		}
	},
	{
		pageIndex: 5,
		component: DocumentUpload,
		title: "Document Upload",
		showInTracker: true,
		routeId: "/Registration/DocumentUpload",
		previousPage: "/Registration/ClaimDetailsTreatment",
		nextPage: "/Registration/Confirmation",
		properties: {
			pageTitle: `${title} - Document Upload`,
			persistUrl: "/api/project",
			lastVisitedPage: "Document Upload",
		},
	},
	{
		pageIndex: 6,
		component: Confirmation,
		title: "Confirmation",
		showInTracker: true,
		routeId: "/Registration/Confirmation",
		previousPage: "/Registration/DocumentUpload",
		nextPage: "/Registration/ThankYou",
		properties: {
			pageTitle: `${title} - Confirmation`,
			nextPageLabel: "Submit",
			persistUrl: `/api/registration`,
			lastVisitedPage: "Confirmation"
		}
	},
	{
		pageIndex: 7,
		component: ThankYou,
		title: "Registration Submitted",
		showInTracker: false,
		routeId: "/Registration/ThankYou",
		properties: {
			pageTitle: `${title} - Thank you`
		}
	},
	{
		pageIndex: 10,
		component: Review,
		title: "Review",
		showInTracker: false,
		routeId: "/Review",
		properties: {
			pageTitle: `${title} - Review`
		}
	},
	{
		pageIndex: 12,
		component: Verify,
		title: "Claimant Registration Form",
		showInTracker: false,
		routeId: "/Verify",
		nextPage: "/Registration/PersonalDetails",
		properties: {
			pageTitle: `${title} - Verify`
		}
	},
	{
		pageIndex: 11,
		component: SaveAndCloseThankYou,
		title: "Registration Saved",
		showInTracker: false,
		routeId: "/Registration/SaveAndClose",
		properties: {
			pageTitle: `${title} - Thank you`
		}
	},
	{
		pageIndex: 13,
		component: RegistrationComplete,
		title: "Registration Complete",
		showInTracker: false,
		routeId: "/RegistrationComplete",
		properties: {
			pageTitle: `${title} - Registration Complete`
		}
	}
];

export default registrationPageList;
